import axios from 'axios'
import apiConfig from '../../config/api-config'

export function fetchContacts() {
  const url = apiConfig.CONTACTS;
  return axios.get(url)
}